<template>
  <portlet
          :icon="'fad fa-users'"
          :title="'Rechten'"
          :actionsBlock="true"
  >
    <template v-if="Can(rights.ROLE_ADD)" slot="actionsBlock">
      <router-link tag="button" :to="{name:'role-create'}" class="btn btn-secondary btn-add-role">
        <i class="fas fa-plus-circle mr-2"></i> Toevoegen
      </router-link>
    </template>
    <template slot="portletBody">

      <datatables
              v-if="getRoles.length && renderedComponent && Can(rights.ROLE_VIEW)"
              :tableClass="tableClass"
              tableID="roles"
              :rows="getRoles"
              :columns="getColumns()"
              :tableInitOptions="tableInitOptions"
              routerLinkClass="dt-router-link"
              :deleteFunction="deleteRole"
              deleteClass="delete"
              :customFilters="customFilters"
              @rowSelected="rowSelected"
      ></datatables>

      <edit-role
        v-if="role"
        :title="'Edit Role'"
        :value="role"
        :name="'role-' + modalId"
        @saveChanges="editRole($event)"
      >
      </edit-role>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import editRole from '../../components/roles/editRole'
  import { Can } from '../../../permission/ability.js';
  import { RIGHTS } from './rights.js';

  export default {
    mixins: [dataTables, swalModals],
    data() {
      return {
        rights: '',
        isAdmin: false,
        role: null,
        customFilters: []
      };
    },
    methods: {
      Can,
      rowSelected(value) {
          this.modalId = value.id;
          this.role = {id: this.modalId, name: value.name, rights: value.rights, department: value.department};
      },
      editRole(role) {
          if (role.name) {
              let id = role.id;

              $('.modal').modal('hide');
              $('.modal-backdrop').remove();

              this.$toasted.global.successRequest({
                  message: 'Rechten aangepast',
              });
              this.$store.dispatch('roles/set', {
                  id,
                  name: role.name,
                  rights: role.rights,
                  department: role.department,
              });

              this.renderComponent();
          }
      },
      deleteRole(role) {
        this.swalDelete(role.name).then(result => {
          if(result.value) {
            this.$store.dispatch('roles/delete', role.id);
            this.$toasted.global.successRequest({
              message: 'Rechten verwijderd'
            });
          }
        });
      },
      getColumns() {
        let self = this;
        return [
          {data: 'name', name: 'Naam', visible: true, searchable: true},
          {
            data: null, name: 'Opties', orderable: false, responsivePriority: 2,
            render(data) {
              var options = '';
              if(Can(RIGHTS.ROLE_EDIT)) {
                  options += '<i title="Rechten aanpassen" class="far fa-edit action-icon get-data" data-target="#role-' + data.id + '" data-toggle="modal"></i>';
              }

              if(Can(RIGHTS.ROLE_DELETE)) {
                  options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
              }
              return options;
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
    },
    created() {
      this.rights = RIGHTS;
      this.isAdmin = this.$store.state.users.me.admin;
    },
    components: {
      editRole
    },
  };
</script>
